import { useState } from 'react';

import { usePageTitle } from '../hooks/usePageTitle';

export default function Counter() {
  usePageTitle('Counter');
  const [currentCount, setCurrentCount] = useState(0);

  return (
    <div className="container page-content py-5">
      <h1>Counter</h1>

      <p role="status">Current count: {currentCount}</p>

      <button
        type="button"
        className="btn btn-primary"
        onClick={() => setCurrentCount((count) => count + 1)}
      >
        Click me
      </button>
    </div>
  );
}
